(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("l8eky", function(module, exports) {

$parcel$export(module.exports, "useDebounce", function () { return $9a74061b8d9cdb1b$export$21805fee57372823; });
$parcel$export(module.exports, "useOnClickOutside", function () { return $9a74061b8d9cdb1b$export$9afc64c180e82dc4; });
$parcel$export(module.exports, "useKeyPress", function () { return $9a74061b8d9cdb1b$export$b65485ca34c366f3; });
$parcel$export(module.exports, "changeCheckboxAriaAttr", function () { return $9a74061b8d9cdb1b$export$fcee17a44533bf4f; });
$parcel$export(module.exports, "gtmPageBuilder", function () { return $9a74061b8d9cdb1b$export$ba7c21bf8d04b182; });
$parcel$export(module.exports, "getLargeObjectTypeIconPath", function () { return $9a74061b8d9cdb1b$export$b4c0e43afc46e381; });
$parcel$export(module.exports, "formatLargeNumbers", function () { return $9a74061b8d9cdb1b$export$dcaf1dbf3e0c13ab; });
$parcel$export(module.exports, "makeCamelCase", function () { return $9a74061b8d9cdb1b$export$44e7716ae1289d49; });
$parcel$export(module.exports, "handleUpAndDown", function () { return $9a74061b8d9cdb1b$export$69242b0ce39e8dd6; });
$parcel$export(module.exports, "focusOnInput", function () { return $9a74061b8d9cdb1b$export$638ec343b26d72db; });
$parcel$export(module.exports, "getDates", function () { return $9a74061b8d9cdb1b$export$dd09f40777b29234; });
$parcel$export(module.exports, "restrictToOnlyLetters", function () { return $9a74061b8d9cdb1b$export$bd0df835003197b0; });
$parcel$export(module.exports, "translateEstateType", function () { return $9a74061b8d9cdb1b$export$8e931dc4399d58f1; });
$parcel$export(module.exports, "GetStatusText", function () { return $9a74061b8d9cdb1b$export$e4c1b429cc7a7158; });
$parcel$export(module.exports, "municipalityCheck", function () { return $9a74061b8d9cdb1b$export$cefe5d5eda7bee66; });
$parcel$export(module.exports, "GetCurrentEstate", function () { return $9a74061b8d9cdb1b$export$47a56b1fff388487; });
$parcel$export(module.exports, "letterTransform", function () { return $9a74061b8d9cdb1b$export$62e765922eb7ba09; });
$parcel$export(module.exports, "getSessionId", function () { return $9a74061b8d9cdb1b$export$b3739caaf2580dd; });
$parcel$export(module.exports, "removeSessionId", function () { return $9a74061b8d9cdb1b$export$587d07e363d643fa; });
$parcel$export(module.exports, "removeLoginType", function () { return $9a74061b8d9cdb1b$export$1a9e7ff3d494e529; });
$parcel$export(module.exports, "officeBrokerGrayScale", function () { return $9a74061b8d9cdb1b$export$50f60048ef8acba; });
$parcel$export(module.exports, "arealTerms", function () { return $9a74061b8d9cdb1b$export$f974294898073a2e; });
$parcel$export(module.exports, "scrollToElementById", function () { return $9a74061b8d9cdb1b$export$9defdf5fd4260665; });
$parcel$export(module.exports, "postalCodeFormatter", function () { return $9a74061b8d9cdb1b$export$408255c143692c3; });
$parcel$export(module.exports, "capitalizeFirstLetter", function () { return $9a74061b8d9cdb1b$export$d07f57595c356899; });
$parcel$export(module.exports, "buildUmbracoImageUrl", function () { return $9a74061b8d9cdb1b$export$8eca4915c8e83d68; });
$parcel$export(module.exports, "getUmbracoImagePosition", function () { return $9a74061b8d9cdb1b$export$b0fb6051ad211f11; });
$parcel$export(module.exports, "setSessionFlagWithExpiry", function () { return $9a74061b8d9cdb1b$export$336f96d7a7ef3a88; });
$parcel$export(module.exports, "getSessionFlagWithExpiry", function () { return $9a74061b8d9cdb1b$export$b7b8e3e7a2da2caa; });

var $dTCkE = parcelRequire("dTCkE");

var $cUbQm = parcelRequire("cUbQm");

var $1A7pc = parcelRequire("1A7pc");

var $80RSc = parcelRequire("80RSc");
function $9a74061b8d9cdb1b$export$21805fee57372823(value, delay) {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = (0, $dTCkE.useState)(value);
    (0, $dTCkE.useEffect)(()=>{
        // Update debounced value after delay
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
}
function $9a74061b8d9cdb1b$export$eacf0f51ec6fbe2c(item, list) {
    return list.includes(item) ? list.filter((i)=>i !== item) : [
        ...list,
        item
    ];
}
function $9a74061b8d9cdb1b$export$9afc64c180e82dc4(ref, handler) {
    (0, $dTCkE.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) return;
            handler();
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler
    ]);
}
function $9a74061b8d9cdb1b$export$b65485ca34c366f3(targetKey) {
    // State for keeping track of whether key is pressed
    const [keyPressed, setKeyPressed] = (0, $dTCkE.useState)(false);
    // If pressed key is our target key then set to true
    // Add event listeners
    (0, $dTCkE.useEffect)(()=>{
        function downHandler({ key: key }) {
            if (key === targetKey) setKeyPressed(true);
        }
        // If released key is our target key then set to false
        const upHandler = ({ key: key })=>{
            if (key === targetKey) setKeyPressed(false);
        };
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);
        // Remove event listeners on cleanup
        return ()=>{
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, [
        targetKey
    ]); // Empty array ensures that effect is only run on mount and unmount
    return keyPressed;
}
function $9a74061b8d9cdb1b$export$fcee17a44533bf4f(e) {
    const item = e.currentTarget;
    switch(item?.getAttribute("aria-checked")){
        case "true":
            item.setAttribute("aria-checked", "false");
            break;
        case "false":
            item.setAttribute("aria-checked", "true");
            break;
    }
}
function $9a74061b8d9cdb1b$export$ba7c21bf8d04b182(officeName) {
    let pageLink = "";
    if (officeName !== undefined) {
        officeName = officeName.toLowerCase().trim();
        const a = "\xe0\xe1\xe2\xe4\xe6\xe3\xe5\u0101\u0103\u0105\xe7\u0107\u010D\u0111\u010F\xe8\xe9\xea\xeb\u0113\u0117\u0119\u011B\u011F\u01F5\u1E27\xee\xef\xed\u012B\u012F\xec\u0131\u0130\u0142\u1E3F\xf1\u0144\u01F9\u0148\xf4\xf6\xf2\xf3\u0153\xf8\u014D\xf5\u0151\u1E55\u0155\u0159\xdf\u015B\u0161\u015F\u0219\u0165\u021B\xfb\xfc\xf9\xfa\u016B\u01D8\u016F\u0171\u0173\u1E83\u1E8D\xff\xfd\u017E\u017A\u017C\xb7/_,:;";
        const b = "aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------";
        const p = new RegExp(a.split("").join("|"), "g");
        officeName = officeName.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, (c)=>b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
        pageLink = window.location.href + "tack/" + officeName;
    }
    return pageLink;
}
function $9a74061b8d9cdb1b$export$8c3d67c5d320a22(estateType) {
    let estateIcon = "";
    if (estateType === (0, $cUbQm.EstateType).House) estateIcon = "liten_villa.svg";
    else if (estateType === (0, $cUbQm.EstateType).Plot) estateIcon = "liten_tomt.svg";
    else if (estateType === (0, $cUbQm.EstateType).Commercial) estateIcon = "liten_kommersiell.svg";
    else if (estateType === (0, $cUbQm.EstateType).Cottage) estateIcon = "liten_fritidshus.svg";
    else if (estateType === (0, $cUbQm.EstateType).Cooperative) estateIcon = "liten_bostadsratt.svg";
    else if (estateType === (0, $cUbQm.EstateType).Agriculture) estateIcon = "liten_gard.svg";
    else if (estateType === (0, $cUbQm.EstateType).Project) estateIcon = "liten_nyproduktion.svg";
    else if (estateType === (0, $cUbQm.EstateType).OwnedApartment) estateIcon = "liten_bostadsratt.svg";
    return estateIcon;
}
function $9a74061b8d9cdb1b$export$b4c0e43afc46e381(estateType, color) {
    let estateIcon = "";
    if (estateType === (0, $cUbQm.EstateType).House) estateIcon = color === "white" ? `stor_villa-white.svg` : "stor_villa.svg";
    else if (estateType === (0, $cUbQm.EstateType).Plot) estateIcon = color === "white" ? `stor_tomt-white.svg` : "stor_tomt.svg";
    else if (estateType === (0, $cUbQm.EstateType).Commercial) estateIcon = color === "white" ? `stor_kommersiell-white.svg` : "stor_kommersiell.svg";
    else if (estateType === (0, $cUbQm.EstateType).Cottage) estateIcon = color === "white" ? `stor_fritidshus-white.svg` : "stor_fritidshus_blue.svg";
    else if (estateType === (0, $cUbQm.EstateType).Cooperative) estateIcon = color === "white" ? `stor_bostadsratt-white.svg` : "stor_bostadsratt.svg";
    else if (estateType === (0, $cUbQm.EstateType).Agriculture) estateIcon = color === "white" ? `stor_gard-white.svg` : "stor_gard.svg";
    else if (estateType === (0, $cUbQm.EstateType).Project) estateIcon = color === "white" ? `stor_nyproduktion-white.svg` : "stor_nyproduktion.svg";
    else if (estateType === (0, $cUbQm.EstateType).OwnedApartment) estateIcon = color === "white" ? `stor_bostadsratt-white.svg` : "stor_bostadsratt.svg";
    else if (estateType === (0, $cUbQm.EstateType).RowHouse) estateIcon = color === "white" ? `stor_parhus-white.svg` : "stor_parhus.svg";
    return estateIcon;
}
function $9a74061b8d9cdb1b$export$dcaf1dbf3e0c13ab(n) {
    if (n === 0) return "0";
    const formattedPrice = [];
    for(; n >= 1000; n = Math.floor(n / 1000))formattedPrice.unshift(String(n % 1000).padStart(3, "0"));
    formattedPrice.unshift(n);
    const finalOutput = formattedPrice.join(" ");
    return finalOutput;
}
function $9a74061b8d9cdb1b$export$44e7716ae1289d49(input) {
    return input?.replace(/(?:^\w|[a-zåäö]|\b\w)/g, function(word, index) {
        return index === 0 ? word.toUpperCase() : word.toLowerCase();
    });
}
function $9a74061b8d9cdb1b$export$69242b0ce39e8dd6(event) {
    if (event.key === "ArrowUp") {
        const parent = document.getElementById("ac-result-list");
        if (parent) {
            const theList = $9a74061b8d9cdb1b$var$getAllFocusableElements(parent);
            const arrayOfFocusableElements = Array.from(theList);
            if (document.activeElement) {
                const indexOfActiveElement = arrayOfFocusableElements.indexOf(document.activeElement);
                if (arrayOfFocusableElements[indexOfActiveElement - 1] !== undefined) arrayOfFocusableElements[indexOfActiveElement - 1].focus();
                return;
            }
        }
    }
    if (event.key === "ArrowDown") {
        const parent = document.getElementById("ac-result-list");
        if (parent) {
            const theList = $9a74061b8d9cdb1b$var$getAllFocusableElements(parent);
            const arrayOfFocusableElements = Array.from(theList);
            if (document.activeElement) {
                const indexOfActiveElement = arrayOfFocusableElements.indexOf(document.activeElement);
                if (arrayOfFocusableElements[indexOfActiveElement + 1] !== undefined) arrayOfFocusableElements[indexOfActiveElement + 1].focus();
                return;
            }
        }
    }
}
const $9a74061b8d9cdb1b$var$getAllFocusableElements = (parent)=>{
    if (!parent) {
        console.warn("You need to pass a parent HTMLElement");
        return []; // Return array so length queries will work
    }
    return parent.querySelectorAll('[href], [tabindex]:not([tabindex="-1"]):not([disabled])');
};
function $9a74061b8d9cdb1b$export$638ec343b26d72db() {
    const searchInputField = document.getElementById("searchfield-input");
    searchInputField?.focus();
}
const $9a74061b8d9cdb1b$export$8619e4a655a41ad9 = (fn)=>{
    const cb = (0, $dTCkE.useRef)(fn); // init with fn, so that type checkers won't assume that current might be undefined
    (0, $dTCkE.useEffect)(()=>{
        cb.current = fn;
    }, [
        fn
    ]);
    (0, $dTCkE.useEffect)(()=>{
        const onUnload = (...args)=>cb.current?.(...args);
        window.addEventListener("beforeunload", onUnload);
        return ()=>window.removeEventListener("beforeunload", onUnload);
    }, []);
};
var $9a74061b8d9cdb1b$export$2e2bcd8739ae039 = $9a74061b8d9cdb1b$export$8619e4a655a41ad9;
function $9a74061b8d9cdb1b$export$dd09f40777b29234(todayDate) {
    let returnDate = "";
    const date = new Date();
    if (todayDate === true) {
        const today = date.toJSON().slice(0, 10);
        returnDate = today;
    } else {
        date.setFullYear(date.getFullYear() + 10);
        const futureTime = date.toJSON().slice(0, 10);
        returnDate = futureTime;
    }
    return returnDate;
}
function $9a74061b8d9cdb1b$export$bd0df835003197b0(e, lettersOnly) {
    if (lettersOnly && (isFinite(Number(e.key)) || e.key === "." || e.key === "," || e.key === "!" || e.key === "#" || e.key === "\u20AC" || e.key === "%" || e.key === "&" || e.key === "/" || e.key === "(" || e.key === ")" || e.key === "=" || e.key === "?" || e.key === "\xa1" || e.key === "\u201D" || e.key === "\xa5" || e.key === "\xa2" || e.key === "\u2030" || e.key === "\xb6" || e.key === "{" || e.key === "}" || e.key === "\u2260" || e.key === "_" || e.key === ":" || e.key === ";" || e.key === "*" || e.key === "\xa8" || e.key === "<" || e.key === ">" || e.key === "\u2264" || e.key === "\u2265" || e.key === "\xbf" || e.key === "`") && e.key !== "Backspace" && e.key !== "Tab" && e.key !== "ArrowRight" && e.key !== "ArrowLeft") e.preventDefault();
}
const $9a74061b8d9cdb1b$export$8e931dc4399d58f1 = (value)=>{
    switch(value){
        case "Villa":
            return "liten_villa.svg";
        case "Tomt":
            return "liten_tomt.svg";
        case "Kommersiellt":
            return "liten_kommersiell.svg";
        case "Fritidshus":
            return "liten_fritidshus.svg";
        case (0, $cUbQm.EstateType).Cooperative:
            return "liten_bostadsratt.svg";
        case "G\xe5rd":
            return "liten_gard.svg";
        case "\xc4garl\xe4genhet":
            return "liten_bostadsratt.svg";
        default:
            return "liten_villa.svg";
    }
};
function $9a74061b8d9cdb1b$export$e4c1b429cc7a7158(id, isSeller, accepted, showOnMyPages) {
    if ((0, $cUbQm.StatusId).ForSale == id || (0, $cUbQm.StatusId).HeadStartHomes == id) return !isSeller ? "Till salu" : "F\xf6rs\xe4ljning p\xe5g\xe5r";
    else if ((0, $cUbQm.StatusId).Intake == id) return !isSeller ? "Ej under publik f\xf6rs\xe4ljning" : accepted ? "Godk\xe4nd, v\xe4ntar p\xe5 m\xe4klare" : showOnMyPages ? "V\xe4ntar p\xe5 godk\xe4nnande" : "M\xe4klaren f\xf6rbereder annonsen";
    else if ((0, $cUbQm.StatusId).Sold == id) return !isSeller ? "S\xe5ld" : "S\xe5lt";
    else if ((0, $cUbQm.StatusId).DuringIntake == id) return "Kontakt med m\xe4klare p\xe5b\xf6rjad";
    else if ((0, $cUbQm.StatusId).Coming == id) return "Kommande f\xf6rs\xe4ljning";
    return "";
}
function $9a74061b8d9cdb1b$export$cefe5d5eda7bee66(value) {
    switch(value){
        case "Gotland":
            return "p\xe5";
        case "Liding\xf6":
            return "p\xe5";
        case "\xd6land":
            return "p\xe5";
        case "Eker\xf6":
            return "p\xe5";
        case "\xd6cker\xf6":
            return "p\xe5";
        case "Orust":
            return "p\xe5";
        case "M\xf6rbyl\xe5nga":
            return "p\xe5";
        case "Tj\xf6rn":
            return "p\xe5";
        case "V\xe4rmd\xf6":
            return "p\xe5";
        case "Hammar\xf6":
            return "p\xe5";
        default:
            return "i";
    }
}
function $9a74061b8d9cdb1b$export$47a56b1fff388487(user, estateId) {
    if (estateId) return user?.objectsImBuying.find((obj)=>obj.id === estateId) ?? user?.objectsImSelling.find((obj)=>obj.id === estateId);
    return user?.objectsImSelling.sort((a, b)=>a.sortIndex - b.sortIndex)[0] ?? user?.objectsImBuying[0];
}
const $9a74061b8d9cdb1b$export$62e765922eb7ba09 = (name)=>{
    return name?.replace(/[åäö]/gi, (match)=>{
        switch(match){
            case "\xe5":
                return "a";
            case "\xe4":
                return "a";
            case "\xf6":
                return "o";
        }
    });
};
const $9a74061b8d9cdb1b$export$b3739caaf2580dd = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).get("sessionId");
};
const $9a74061b8d9cdb1b$export$587d07e363d643fa = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).remove("sessionId");
};
const $9a74061b8d9cdb1b$export$1a9e7ff3d494e529 = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).remove("loginType");
};
function $9a74061b8d9cdb1b$export$c6e2787f63ca055d(str) {
    return str === null || str.match(/^ *$/) !== null;
}
const $9a74061b8d9cdb1b$export$50f60048ef8acba = (office)=>{
    switch(office){
        case "Sollentuna":
            return true;
        case "Sundbyberg":
            return true;
        case "Solna":
            return true;
        case "\xd6ster\xe5ker":
            return true;
        default:
            return false;
    }
};
const $9a74061b8d9cdb1b$export$f974294898073a2e = (value)=>{
    switch(value){
        case "forest":
            return "Skog";
        case "wasteLand":
            return "Impediment";
        case "arabel":
            return "\xc5ker";
        case "infield":
            return "In\xe4gomark";
        case "pasture":
            return "Bete";
        case "water":
            return "Vatten";
        case "other":
            return "\xd6vrigt";
        case "totalArea":
            return "Totalt";
        case "Skogsbruksplan":
            return "Areal enligt skogsbruksplan";
        default:
            return value;
    }
};
const $9a74061b8d9cdb1b$export$1567cc001e3d0c1d = (endValue, duration)=>{
    const [currentValue, setCurrentValue] = (0, $dTCkE.useState)(0);
    (0, $dTCkE.useEffect)(()=>{
        let startTime = null;
        let animationFrame;
        const startAnimation = (timestamp)=>{
            if (!startTime) startTime = timestamp;
            const elapsedTime = timestamp - startTime;
            const progress = Math.min(1, elapsedTime / duration);
            const newValue = Math.floor(progress * endValue);
            setCurrentValue(newValue);
            if (progress < 1) animationFrame = requestAnimationFrame(startAnimation);
        };
        animationFrame = requestAnimationFrame(startAnimation);
        return ()=>cancelAnimationFrame(animationFrame);
    }, [
        endValue,
        duration
    ]);
};
const $9a74061b8d9cdb1b$export$9defdf5fd4260665 = (e)=>{
    const element = document.getElementById(e);
    element.scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
};
const $9a74061b8d9cdb1b$export$408255c143692c3 = (str)=>{
    if (str.length < 3) return str;
    const part1 = str.slice(0, 3);
    const part2 = str.slice(3);
    return `${part1} ${part2}`;
};
function $9a74061b8d9cdb1b$export$90a76a0e4122dd3a(elementId, behavior = "smooth", position = "center") {
    const element = document.getElementById(elementId)?.firstChild;
    element?.scrollIntoView({
        behavior: behavior,
        block: position
    });
}
const $9a74061b8d9cdb1b$export$d07f57595c356899 = (str)=>{
    if (!str) return "";
    return str.toLowerCase().split(" ").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
const $9a74061b8d9cdb1b$export$8eca4915c8e83d68 = (url, crop, focalPoint, fallbackWidth, fallBackHeight)=>{
    const width = crop?.width ?? fallbackWidth;
    const height = crop?.height ?? fallBackHeight;
    if (crop?.coordinates) return `${url}?cc=${crop?.coordinates?.x1},${crop?.coordinates?.y1},${crop?.coordinates?.x2},${crop?.coordinates?.y2}&width=${width}&height=${height}&format=webp`;
    else if (focalPoint) return `${url}?rxy=${focalPoint.left},${focalPoint?.top}&width=${width}&height=${height}&format=webp`;
    else return `${url}?width=${width}&height=${height}&format=webp`;
};
const $9a74061b8d9cdb1b$export$b0fb6051ad211f11 = (focalPoint)=>{
    if (focalPoint) return {
        objectPosition: `${focalPoint.left * 100}% ${focalPoint.top * 100}%`
    };
};
const $9a74061b8d9cdb1b$export$e0c08d15c4f9dab5 = (resp)=>{
    return typeof resp === "string" ? JSON.parse(resp) : resp;
};
const $9a74061b8d9cdb1b$export$336f96d7a7ef3a88 = (key, value, expiryTimeMs)=>{
    const expiryTimestamp = Date.now() + expiryTimeMs;
    const data = {
        value: value,
        expiryTimestamp: expiryTimestamp
    };
    sessionStorage.setItem(key, JSON.stringify(data));
};
const $9a74061b8d9cdb1b$export$b7b8e3e7a2da2caa = (key)=>{
    const data = sessionStorage.getItem(key);
    if (!data) return null;
    const { value: value, expiryTimestamp: expiryTimestamp } = JSON.parse(data);
    // Check if the current time is past the expiration time
    if (Date.now() > expiryTimestamp) {
        sessionStorage.removeItem(key); // Invalidate the expired key
        return null;
    }
    return value;
};
const $9a74061b8d9cdb1b$export$b1be5d22f8c2836d = (markerLatLng, poly // Update polygon type to match new format
)=>{
    // Convert markerLatLng to L.LatLng
    const marker = $80RSc.latLng(markerLatLng.lat, markerLatLng.lng);
    // Convert polygon points to L.LatLng[]
    const polyPoints = poly[0].map((point)=>$80RSc.latLng(point.lat, point.lng));
    const x = marker.lat, y = marker.lng;
    let inside = false;
    for(let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++){
        const xi = polyPoints[i].lat, yi = polyPoints[i].lng;
        const xj = polyPoints[j].lat, yj = polyPoints[j].lng;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
};

});

})();
//# sourceMappingURL=ObjectPage.ff796752.js.map
